import { render } from "./MenuMain2.vue?vue&type=template&id=014996ba&scoped=true"
import script from "./MenuMain2.vue?vue&type=script&lang=js"
export * from "./MenuMain2.vue?vue&type=script&lang=js"

import "./MenuMain2.vue?vue&type=style&index=0&id=014996ba&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-014996ba"]])

export default __exports__